var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Category',{attrs:{"cate-name":"new-face","category-name":"新人賞","category-intro":"2020年に創刊されたメルマガの中から「いちばん読みたい・読んでもらいたいメルマガ」に輝いた新人賞5誌を発表いたします。"}})}
var staticRenderFns = []

export { render, staticRenderFns }